import { render, staticRenderFns } from "./MoveToFMGForm.vue?vue&type=template&id=0e588686&scoped=true"
import script from "./MoveToFMGForm.vue?vue&type=script&lang=ts"
export * from "./MoveToFMGForm.vue?vue&type=script&lang=ts"
import style0 from "./MoveToFMGForm.vue?vue&type=style&index=0&id=0e588686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e588686",
  null
  
)

export default component.exports